import { render, staticRenderFns } from "./MetricsEmployeeProjectPeriod.vue?vue&type=template&id=2f2b5054"
import script from "./MetricsEmployeeProjectPeriod.vue?vue&type=script&lang=js"
export * from "./MetricsEmployeeProjectPeriod.vue?vue&type=script&lang=js"
import style0 from "./MetricsEmployeeProjectPeriod.vue?vue&type=style&index=0&id=2f2b5054&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports